import { render, staticRenderFns } from "./StudyList.vue?vue&type=template&id=234c7476&scoped=true&lang=pug"
import script from "./StudyList.vue?vue&type=script&lang=ts"
export * from "./StudyList.vue?vue&type=script&lang=ts"
import style0 from "./StudyList.vue?vue&type=style&index=0&id=234c7476&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234c7476",
  null
  
)

export default component.exports